/* Copyright (C) NewFoundry 2022 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

var _classCallCheck = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.style = exports.mapStateToProps = exports.name = exports.ThankYou = void 0;

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var react_clipboard_js_1 = __importDefault(require("react-clipboard.js"));

var StyleUtils_1 = __importDefault(require("./utils/StyleUtils"));

var name = 'ThankYou';
exports.name = name;

var ThankYou = function ThankYou(_ref) {
  var Frame = _ref.Frame,
      Button = _ref.Button,
      Image = _ref.Image,
      Text = _ref.Text,
      styles = _ref.styles;
  return /*#__PURE__*/function (_react_1$default$Pure) {
    _inherits(_class, _react_1$default$Pure);

    var _super = _createSuper(_class);

    function _class(props) {
      _classCallCheck(this, _class);

      return _super.call(this, props);
    }

    _createClass(_class, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            after = _this$props.after,
            before = _this$props.before,
            classes = _this$props.classes,
            configCode = _this$props.configCode,
            subHeader = _this$props.subHeader;
        return react_1.default.createElement(Frame, {
          className: ['ThankYou__container', classes === null || classes === void 0 ? void 0 : classes.container],
          style: styles === null || styles === void 0 ? void 0 : styles.container
        }, before, react_1.default.createElement(Text, {
          className: ['ThankYou__thank-you', classes === null || classes === void 0 ? void 0 : classes.thankYou],
          style: styles === null || styles === void 0 ? void 0 : styles.thankYou
        }, "Thank You!"), subHeader && react_1.default.createElement(Text, {
          className: ['ThankYou__sub-header', classes === null || classes === void 0 ? void 0 : classes.subHeader],
          style: styles === null || styles === void 0 ? void 0 : styles.subHeader
        }, subHeader), react_1.default.createElement(Frame, {
          className: ['ThankYou__edit-build-container', classes === null || classes === void 0 ? void 0 : classes.editBuildContainer],
          style: styles === null || styles === void 0 ? void 0 : styles.editBuildContainer
        }, react_1.default.createElement(Button, {
          className: ['ThankYou__edit-build', classes === null || classes === void 0 ? void 0 : classes.editBuild],
          style: styles === null || styles === void 0 ? void 0 : styles.editBuild
        }, "Edit Build"), react_1.default.createElement(Frame, {
          className: ['ThankYou__build-code-container', classes === null || classes === void 0 ? void 0 : classes.buildCodeContainer],
          style: styles === null || styles === void 0 ? void 0 : styles.buildCodeContainer
        }, react_1.default.createElement(Text, {
          className: ['ThankYou__build-code', classes === null || classes === void 0 ? void 0 : classes.buildCode],
          style: styles === null || styles === void 0 ? void 0 : styles.buildCode
        }, configCode), react_1.default.createElement(react_clipboard_js_1.default, {
          className: classnames_1.default(['ThankYou__copy-to-clipboard', classes === null || classes === void 0 ? void 0 : classes.copyToClipboard]),
          style: styles === null || styles === void 0 ? void 0 : styles.copyToClipboard,
          "data-clipboard-text": configCode
        }, "Copy to Clipboard"))), after);
      }
    }]);

    return _class;
  }(react_1.default.PureComponent);
};

exports.ThankYou = ThankYou;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var api = state.api;
  var configCode = api.data.configCode;
  return {
    configCode: configCode
  };
};

exports.mapStateToProps = mapStateToProps;

var style = function style(theme) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;

  return {
    buildCode: Object.assign({
      backgroundColor: (_a = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _a === void 0 ? void 0 : _a.primary,
      color: '#fff',
      height: 48,
      fontSize: 35,
      fontWeight: 300,
      lineHeight: '42px',
      textAlign: 'center'
    }, (_b = theme === null || theme === void 0 ? void 0 : theme.ThankYou) === null || _b === void 0 ? void 0 : _b.buildCode),
    buildCodeContainer: Object.assign({
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      marginLeft: 8
    }, (_c = theme === null || theme === void 0 ? void 0 : theme.ThankYou) === null || _c === void 0 ? void 0 : _c.buildCodeContainer),
    container: Object.assign({
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      paddingTop: 25,
      width: '100%'
    }, (_d = theme === null || theme === void 0 ? void 0 : theme.ThankYou) === null || _d === void 0 ? void 0 : _d.container),
    copyImage: Object.assign({
      marginRight: 5,
      position: 'relative',
      top: 2,
      width: 15
    }, (_e = theme === null || theme === void 0 ? void 0 : theme.ThankYou) === null || _e === void 0 ? void 0 : _e.copyImage),
    copyToClipboard: Object.assign(Object.assign(Object.assign({
      border: 0,
      color: (_f = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _f === void 0 ? void 0 : _f.primary,
      cursor: 'pointer',
      fontSize: 13,
      fontWeight: '400'
    }, StyleUtils_1.default.padding('8px 16px')), {
      textTransform: 'uppercase'
    }), (_g = theme === null || theme === void 0 ? void 0 : theme.ThankYou) === null || _g === void 0 ? void 0 : _g.copyToClipboard),
    editBuild: Object.assign(Object.assign(Object.assign({}, StyleUtils_1.default.border('2px solid #000')), {
      borderColor: (_h = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _h === void 0 ? void 0 : _h.secondary,
      borderRadius: 6,
      display: 'flex',
      height: 48,
      flex: 1,
      fontSize: 18,
      fontWeight: 300,
      justifyContent: 'center',
      lineHeight: '42px',
      textTransform: 'uppercase'
    }), (_j = theme === null || theme === void 0 ? void 0 : theme.ThankYou) === null || _j === void 0 ? void 0 : _j.editBuild),
    editBuildContainer: Object.assign({
      display: 'flex',
      flexDirection: 'row',
      marginBottom: 40,
      width: '100%'
    }, (_k = theme === null || theme === void 0 ? void 0 : theme.ThankYou) === null || _k === void 0 ? void 0 : _k.editBuildContainer),
    subHeader: Object.assign({
      color: (_l = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _l === void 0 ? void 0 : _l.primary,
      fontSize: 20,
      fontWeight: '300',
      lineHeight: '25px',
      marginBottom: 25,
      textAlign: 'center'
    }, (_m = theme === null || theme === void 0 ? void 0 : theme.ThankYou) === null || _m === void 0 ? void 0 : _m.subHeader),
    thankYou: Object.assign({
      color: (_o = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _o === void 0 ? void 0 : _o.primary,
      fontSize: 28,
      fontWeight: '300',
      marginBottom: 25
    }, (_p = theme === null || theme === void 0 ? void 0 : theme.ThankYou) === null || _p === void 0 ? void 0 : _p.thankYou)
  };
};

exports.style = style;